import { Link } from "react-router-dom";
import Logo from "../svg/Logo.jsx";
import { EMPRESA, esPendiente } from "../../lib/config";
import EnlaceCotizar from "../ui/EnlaceCotizar.jsx";
import { useCategorias } from "../../lib/useCatalogo";
import s from "./Footer.module.css";

export default function Footer() {
  const { categorias } = useCategorias();
  const anio = new Date().getFullYear();

  return (
    <footer className={s.footer}>
      <div className={`container ${s.grid}`}>
        <div className={s.marca}>
          <Logo className={s.logo} variante="texto" />
          <p className={s.eslogan}>{EMPRESA.eslogan}</p>
          <p className={s.dato}>
            {!esPendiente(EMPRESA.direccion) && (
              <>
                {EMPRESA.direccion}
                <br />
              </>
            )}
            {EMPRESA.ciudad}
          </p>
        </div>

        <nav className={s.columna} aria-label="Catalogo">
          <h4 className={s.titulo}>Catalogo</h4>
          <ul className={s.lista}>
            {categorias.map((c) => (
              <li key={c.id}>
                <Link to={`/productos?categoria=${c.slug}`}>{c.nombre}</Link>
              </li>
            ))}
            {categorias.length === 0 && (
              <li><Link to="/productos">Ver catalogo</Link></li>
            )}
          </ul>
        </nav>

        <nav className={s.columna} aria-label="Empresa">
          <h4 className={s.titulo}>Empresa</h4>
          <ul className={s.lista}>
            <li><Link to="/nosotros">Nosotros</Link></li>
            <li><Link to="/servicios">Servicios</Link></li>
            <li><EnlaceCotizar>Cotizador</EnlaceCotizar></li>
            <li><Link to="/contacto">Contacto</Link></li>
            <li><Link to="/cuenta">Mi cuenta</Link></li>
          </ul>
        </nav>

        <div className={s.columna}>
          <h4 className={s.titulo}>Contacto</h4>
          <ul className={s.lista}>
            <li>
              <a href={`mailto:${EMPRESA.email}`}>{EMPRESA.email}</a>
            </li>
            {!esPendiente(EMPRESA.telefono) && (
              <li className="mono">{EMPRESA.telefono}</li>
            )}
            <li className={s.horario}>{EMPRESA.horario}</li>
          </ul>
        </div>
      </div>

      <div className={`container ${s.legal}`}>
        <p className="mono">
          {/* Se omite lo que siga pendiente en vez de publicar el marcador, y
              no se repite el nombre si la razon social ya lo contiene. */}
          {[
            `© ${anio} ${
              !esPendiente(EMPRESA.legal) ? EMPRESA.legal : EMPRESA.nombre
            }`,
            !esPendiente(EMPRESA.ruc) ? `RUC ${EMPRESA.ruc}` : null,
          ]
            .filter(Boolean)
            .join(" · ")}
        </p>
        <p className={s.creditos}>
          <Link to="/admin">Panel</Link>
        </p>
      </div>
    </footer>
  );
}
